module.exports = __webpack_public_path__ + "static/media/invoice.38015d2b.png";